// Third-party packages
import {
	PUBLIC_ROUTES_GLOBAL,
} from '@routes/lpdipro/public';
import {
	memo,
} from 'react';
import {
	withTranslation,
} from 'react-i18next';
import {
	useRoutes,
} from 'react-router-dom';

const PublicRoutes = () => useRoutes(PUBLIC_ROUTES_GLOBAL);
export const AppPublic = memo(withTranslation()(PublicRoutes));
